import React from "react";

export default function ColorFrame31({ fill, frameTextToggle, children }) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
    >
      <g transform={frameTextToggle}>
        <path
          fill="#C6D0E0"
          d="M19 31.985a8.613 8.613 0 018.613-8.614h36.073a7.771 7.771 0 017.771 7.772v1.684a7.771 7.771 0 01-7.771 7.771H27.613A8.613 8.613 0 0119 31.985zM19 115.657a8.613 8.613 0 018.613-8.613h36.073a7.771 7.771 0 017.771 7.771v1.684a7.771 7.771 0 01-7.771 7.771H27.613A8.613 8.613 0 0119 115.657zM19 73.82a8.613 8.613 0 018.613-8.612h36.073a7.771 7.771 0 017.771 7.77v1.685a7.771 7.771 0 01-7.771 7.771H27.613A8.613 8.613 0 0119 73.821zM19 157.493a8.613 8.613 0 018.613-8.613h36.073a7.771 7.771 0 017.771 7.771v1.684a7.772 7.772 0 01-7.771 7.772H27.613A8.614 8.614 0 0119 157.493zM19 199.329a8.613 8.613 0 018.613-8.613h36.073a7.771 7.771 0 017.771 7.771v1.684a7.772 7.772 0 01-7.771 7.772H27.613A8.614 8.614 0 0119 199.329zM19 240.842a8.613 8.613 0 018.613-8.613h36.073A7.771 7.771 0 0171.457 240v1.684a7.771 7.771 0 01-7.771 7.771H27.613A8.613 8.613 0 0119 240.842z"
        ></path>
        <rect
          width="216.629"
          height="272"
          x="40.371"
          y="2"
          fill={fill}
          rx="7.771"
        ></rect>
        <rect
          width="124"
          height="123"
          x="87"
          y="124"
          fill="#fff"
          stroke="#FFEABC"
          strokeWidth="8"
          rx="61.5"
        ></rect>
        <path
          fill="#FFEABC"
          d="M103.979 101.857v-20.3h3.886l8.642 14.326h-2.059l8.497-14.326h3.857l.058 20.3h-4.408l-.029-13.543h.812l-6.786 11.397h-2.117l-6.931-11.397h.986v13.543h-4.408zm32.018-12.122h9.773v3.654h-9.773v-3.654zm.348 8.352h11.049v3.77h-15.718v-20.3h15.341v3.77h-10.672v12.76zm14.787 3.77v-20.3h3.886l11.977 14.616h-1.885V81.557h4.64v20.3h-3.857l-12.006-14.616h1.885v14.616h-4.64zm32.44.348c-2.881 0-5.133-.802-6.757-2.407-1.624-1.605-2.436-3.895-2.436-6.873V81.557h4.698v11.194c0 1.933.396 3.325 1.189 4.176.792.85 1.904 1.276 3.335 1.276 1.43 0 2.542-.425 3.335-1.276.792-.85 1.189-2.243 1.189-4.176V81.557h4.64v11.368c0 2.978-.812 5.269-2.436 6.873-1.624 1.605-3.877 2.407-6.757 2.407z"
        ></path>
        <path
          fill="#ED583C"
          d="M122.943 47.657H175.4v4.563c0 9.283-7.526 16.809-16.809 16.809h-18.839c-9.283 0-16.809-7.526-16.809-16.81v-4.562z"
        ></path>
        <mask
          id="mask0_2257_162823"
          style={{ maskType: "alpha" }}
          width="54"
          height="23"
          x="122"
          y="47"
          maskUnits="userSpaceOnUse"
        >
          <path
            fill="#ED583C"
            d="M122.943 47.657H175.4v4.563c0 9.283-7.526 16.809-16.809 16.809h-18.839c-9.283 0-16.809-7.526-16.809-16.81v-4.562z"
          ></path>
        </mask>
        <g mask="url(#mask0_2257_162823)">
          <path
            fill="#ED583C"
            d="M126.829 66.777s16.118 0 31.085-10.046C172.882 46.686 189 46.686 189 46.686v8.448c0 9.283-7.526 16.809-16.809 16.809h-40.196a5.166 5.166 0 01-5.166-5.166z"
            opacity="0.5"
          ></path>
        </g>
        <path
          fill="#FFEABC"
          d="M159.843 31.329c.375-2.998 4.215-5.62 6.089-6.558-1.093 1.406-2.623 4.684 0 6.558 3.278 2.341-2.342 11.709-.937 7.962s-5.62-4.215-5.152-7.962zM144.855 31.329c.375-2.998 4.216-5.62 6.089-6.558-1.093 1.406-2.623 4.684 0 6.558 3.279 2.341-2.342 11.709-.937 7.962s-5.62-4.215-5.152-7.962zM129.868 31.329c.374-2.998 4.215-5.62 6.088-6.558-1.092 1.406-2.622 4.684 0 6.558 3.279 2.341-2.341 11.709-.936 7.962 1.405-3.747-5.621-4.215-5.152-7.962z"
        ></path>
        {children}
      </g>
    </svg>
  );
}
